import styled from '@emotion/styled';

export const LabelContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 10px;
  align-items: center;
`;

export const Icon = styled.img<{ size: number }>`
  width: ${(props) => `${props.size}px`};
  height: ${(props) => `${props.size}px`};
  object-fit: cover;
`;
